import React from 'react'
import css from '../Modulecss/Home.module.css'
import { Link } from 'react-router-dom'
import Header from '../Components/Header'

export default function RunningCard ({ runnig, winnAmount, game_type  }) {
  const user = localStorage.getItem("userId");
  const entryAmount = Number(runnig?.Game_Ammount || 0);
  const totalPrize = entryAmount + winnAmount(entryAmount);
  const leftPlayer = runnig?.Created_by?.Name || "Player 1";
  const rightPlayer = runnig?.Accepetd_By?.Name || "Player 2";

  return (
    <div className={`${css.runningBattleCard} mt-1`}>
      <div className={css.runningBattleHeader}>
        <div className={css.playingForBadge}>Playing For</div>
        <div className={css.playersBadge}>
          <span>{leftPlayer}</span>
          <span className={css.andText}>&</span>
          <span>{rightPlayer}</span>
        </div>
        <div className={css.crownWrap}>
          <img src="/images/global-cash-won-green-circular.png" alt="" />
        </div>
      </div>

      <div className={css.runningBattleRow}>
        <div className={css.amountCard}>
          <div className={css.amountCardLabel}>ENTRY FEE</div>
          <div className={css.amountValue}>
            <span className={css.rupeeIcon}>₹</span>
            <span>{entryAmount}</span>
          </div>
        </div>

        <div className={css.vsOuterRing}>
          <div className={css.vsInnerRing}>VS</div>
        </div>

        <div className={css.amountCardPrize}>
          <div className={css.winPrizeLabel}>WINNING PRIZE</div>
          <div className={css.amountValue}>
            <span className={css.rupeeIcon}>₹</span>
            <span>{totalPrize}</span>
          </div>
        </div>
      </div>

      {(user == runnig?.Accepetd_By?._id || user == runnig?.Created_by?._id) && (
        <Link
          className={`${css.bgSecondary} ${css.playButton} ${css.cxy} position-relative mx-1 ${
            runnig?.Status == 'conflict' ? 'bg-danger' : 'bg-success'
          }`}
          style={{
            right: '0px',
            top: '-6px',
            padding: '10px 17px'
          }}
          to={{
            pathname: `/viewgame1/${runnig?._id}`,
            state: { prevPath: window.location.pathname }
          }}
        >
          view
        </Link>
      )}
    </div>
  )
}
